import { render, staticRenderFns } from "./GatewayIcon.global.vue?vue&type=template&id=e36d7078&scoped=true&lang=pug&"
import script from "./GatewayIcon.global.vue?vue&type=script&lang=ts&"
export * from "./GatewayIcon.global.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayIcon.global.vue?vue&type=style&index=0&id=e36d7078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36d7078",
  null
  
)

export default component.exports